export { default as initSmartlook } from "./smartlook";
